import { useEffect } from 'react';
import {
  ColorMode,
  useColorMode,
} from '@antimatterhq/ui/contexts/ColorModeContext';

export function useParentDarkModeSync() {
  const { setColorMode } = useColorMode();
  // const { PARENT_FRAME_ORIGIN } = useConfig();

  useEffect(() => {
    const messageHandler = (event: MessageEvent) => {
      // TODO: enable
      // if (!PARENT_FRAME_ORIGIN || event.origin !== PARENT_FRAME_ORIGIN) {
      //   console.error(`unable to verify  origin for message: ${event}`);
      //   return;
      // }

      const { colorMode } = event.data;

      if (colorMode !== undefined) {
        setColorMode(colorMode as ColorMode);
      }
    };

    window?.addEventListener('message', messageHandler);

    return () => {
      window?.removeEventListener('message', messageHandler);
    };
  }, [setColorMode]);
}
